/**
 * Home page content – single source of truth for all copy on the home page.
 * Edit strings here; they are used by Home.js and by components for fallbacks.
 */

export const homePageContent = {
  // Hero / Banner (dark section)
  banner: {
    title: 'Building Skills That Actually Matters',
    subtitle:
      'See how AI and cloud technologies are transforming modern businesses, gain the skills to design what tomorrow’s companies will depend on.',
    ctaLink: 'https://calendar.app.google/LUJkRHXkByMJcQ39A',
    demoCtaText: 'Schedule a call',
    tags: ['AI First Approach'],
  },

  // Tagline (small section right after banner) – 3 lines
  tagline: [
    'We are future-focused learning platform',
    'dedicated to building limitless skills and',
    'empowering individuals to achieve their highest potential.',
  ],

  // Sections
  courses: {
    title: 'Industry-Ready Programs',
    subtitle:
      'We specialize in job-readiness programs that empower you to accelerate your tech career through personalized learning paths and hands-on training. Our focus goes beyond building careers — we develop future leaders who shape and advance the technology landscape.',
  },
  featureSection: {
    sectionHeading: 'Why Choose Us',
  },
  blog: {
    title: 'From Our Blog',
  },
  reviews: {
    title: 'Read reviews, learn with confidence.',
    ratingLabel: '4.9/5',
    reviewCountLabel: 'Based on 1200+ reviews',
    introText: 'What our learners are saying',
  },
  foundersAchievement: {
    title: 'Founders Achievement',
    subtitle:
      "Khyati Mehta has impacted 1000+ Trailblazers through learning, mentoring, and career support. She is the Founder of WITdreamin — India’s only women-led Salesforce community conference — and is known as India’s first Salesforce podcaster, sharing real career stories from the ecosystem.A Salesforce Marketing Champion, Trailblazer Community Leader, Speaker, and Mentor, she actively promotes Salesforce and AI learning across India and APAC. She was proudly featured on the big stage screen at TDX25 and recognized by Salesforce for her nonprofit contributions. Khyati continues to inspire and support the next generation of Salesforce professionals.",
  },
  form: {
    title: 'Get in Touch',
    subtitle:
      "We'd love to answer your queries. Send us a message and we'll respond as soon as we can.",
  },
};

export default homePageContent;
